module.exports = __webpack_public_path__ + "img/carrot.a388dad7.svg";